import { useEffect } from "react";
import { RouterProvider } from "react-router";

import "./api/interceptors";
import "./i18n";
import { AppProviders } from "./providers";
import { router } from "./router";
import { subscribeDocumentMetadata } from "./router/document-metadata";
import "./styles/index.css";

function App() {
  useEffect(() => subscribeDocumentMetadata(), []);

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
